/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { createImage, readImagesByURL } from '../image.db';
import { BlobImage } from '../models/image.model';
import { map } from 'rxjs/operators';
import { config } from '../confing';
import { OauthService } from './oauth.service';
import { catchError, retry } from 'rxjs/operators';
export type Book = {
  id: string;
  volumeInfo: {
    title: string;
    subtitle: string;
    authors: string[];
    publisher: string;
    publishDate: string;
    description: string;
    averageRating: number;
    ratingsCount: number;
    imageLinks: {
      thumbnail: string;
      smallThumbnail: string;
    };
  };
};



@Injectable({
  providedIn: 'root'
})
export class ImageService {

  private GOOGLE_API_PATH = 'https://www.googleapis.com/books/v1/volumes';
  constructor(
    private sanitizer: DomSanitizer,
    private httpClient: HttpClient,
    private oauth: OauthService
  ) {}


  googleSearch(query: string): Observable<Book[]> {
    return this.httpClient
      .get<{ items: Book[] }>(`${this.GOOGLE_API_PATH}?q=isbn:${query}`)
      .pipe(map(books => books.items || []));
  }


  /**
   * This method attemps to load the image array
   * from the database, and if it is not found,
   * it encodes the image, saves it and returns the
   * encode {@link BlobImage }
   *
   * This way it should be available in the database on future
   * requests.
   *
   * @param url The image URL
   */
   getImageFromBlob(blob) {

    const safeURL: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(
      URL.createObjectURL(blob)
    );

    return safeURL;
  }

  /**
   * @param url The SafeUrl instance
   */
  private getSafeBackgroundImageUrl(url: any) {
    return `url("${url.changingThisBreaksApplicationSecurity}")`;
  }

  fetchImage(URL): Observable<Blob> {
    const header = new HttpHeaders({
   /*   Host : 'media.sanpaolostore.it',*/
      'Cache-Control' : 'no-cache',
      /*'Access-Control-Allow-Origin' : 'media.sanpaolostore.it'*/

    });

    /* return this.httpclient.get(imageUrl, { responseType: 'blob' }); */
    return this.httpClient.get(URL, {
      responseType: 'blob', headers: header
    });
  }


  /**
   * Save the blob image to the database.
   * It first checks whether there exists an
   * image with the URL in the database.
   *
   * @param url The URL of the image
   * @param blob The blob
   */
  async saveImageToDatabase(url: string, blob: Blob) {
    if ((await readImagesByURL(url)).length === 0) {
      const blobImage = new BlobImage(url, blob, blob.type);
      createImage(blobImage);
    }
  }

   getUrl(ean: string) {
      const token = this.oauth.getToken();
      const header = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    });
    const options = {
      headers: header
    };
    return  this.httpClient.get(`${config[config.env].base_url}/image/${ean}`, options);
  }

  getImage(ean: string): Observable<Blob> {
    const token = this.oauth.getToken();
    const URL = `${config[config.env].base_url}/image/${ean}`;
    const header = new HttpHeaders({
   /*   Host : 'media.sanpaolostore.it',*/
      'Cache-Control' : 'no-cache',
      Authorization: 'Bearer ' + token
      /*'Access-Control-Allow-Origin' : 'media.sanpaolostore.it'*/
    });

    /* return this.httpclient.get(imageUrl, { responseType: 'blob' }); */
    return this.httpClient.get(URL, {
      responseType: 'blob', headers: header
    });
  }
}
